import { useOauth } from "@/hooks/use-oauth";
import { AuthProvider } from "@nitro-ape/shared/models/enums/auth-provider";
import LoginPageContent from "@/routes/login/-components/LoginPageContent";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/auth/login/discord")({
  component: DiscordCallbackContent,
});

function DiscordCallbackContent() {
  const { handleOauthCallback, isLoading, response, onContinue } = useOauth(
    AuthProvider.DISCORD,
  );
  const { code, state } = useSearch({ from: "/auth/login/discord" });

  useEffect(() => {
    handleOauthCallback(code, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginPageContent
      isGoogleLoading={false}
      initiateGoogleLogin={() => {}}
      isDiscordLoading={isLoading}
      initiateDiscordLogin={() => {}}
      isTelegramLoading={false}
      onRecoveryKeyContinue={onContinue}
      recoveryKey={response?.recovery_key}
    />
  );
}
